import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
import * as firebase from "firebase";

const idioma = "IDIOMA";
const semillas = "SEMILLAS";
const slides = "slides";

const AppVersion = "2.0.4";

@Injectable()
export class ConfigService {
  private idioma: string;
  private showSeeds: string;
  private gasPrice: string;
  private gasLimit: string;
  private showSlides: string;
  private minGas;
  private version: string;
  private address_to: string;
  private amount: string;

  constructor(
    private storage: Storage,
    private translateService: TranslateService
  ) {
    this.storage.get(idioma).then((value) => {
      if (value) {
        console.log("Constructor vAlue idiom gaurdado " + value);
        this.idioma = value;
        this.translateService.use(value);
      } else {
        if (this.translateService.getBrowserLang() !== undefined) {
          var idioma = this.translateService.getBrowserLang();
          if (idioma === "es" || idioma === "en") {
            console.log(
              "idioma navegador ",
              this.translateService.getBrowserLang()
            );
            this.translateService.use(this.translateService.getBrowserLang());
          } else {
            this.translateService.setDefaultLang("en");
            this.translateService.use("en");
          }
        } else {
          this.translateService.setDefaultLang("es");
          this.translateService.use("es"); // Set your language here
        }
        console.log(
          "Consturctor value vacio inicializamos a en " +
            value +
            " current lang " +
            this.translateService.currentLang
        );
        this.storage.set(idioma, this.translateService.currentLang);
        this.idioma = this.translateService.currentLang;
      }
    });

    this.storage.get(semillas).then((show) => {
      if (show) {
        this.showSeeds = show;
      } else {
        this.showSeeds = "yes";
      }
    });

    this.storage.get(slides).then((showSlides) => {
      if (showSlides) {
        this.showSlides = showSlides;
      } else {
        this.showSlides = "yes";
      }
    });
  }

  getIdiom() {
    if (this.idioma) {
      return this.idioma.slice();
    } else {
      return "es";
    }
  }

  setIdiom(idiom: string) {
    this.storage.set(idioma, idiom).then((value) => {
      console.log("cambiamos el valor del idioma. " + value);
      this.idioma = idiom;
    });
  }

  getShowSeedsMessage() {
    return this.showSeeds;
  }

  setShowSeedsMessage(show: string) {
    this.storage.set(semillas, show).then((show) => {
      this.showSeeds = show;
    });
  }

  getShowSlides() {
    if (this.showSlides) {
      return this.showSlides;
    } else {
      return "yes";
    }
  }

  setShowSlides(showSlides: string) {
    this.storage.set(slides, showSlides).then((showSlides) => {
      this.showSlides = showSlides;
    });
  }

  //PRODUCTION

  fetchGasProdConfigFan() {
    return new Promise((resolve, reject) => {
      firebase
        .database()
        .ref("/prod_configFan")
        .once("value")
        .then((snapshot) => {
          if (snapshot.val()) {
            var gasParameters = snapshot.val();
            this.gasPrice = gasParameters.GasPrice;
            this.minGas = gasParameters.minGas;
            this.version = gasParameters.version;
            this.amount = gasParameters.amount;
            this.address_to = gasParameters.address_to;
            var ok;
            if (this.minGas === 0.0000186) {
              ok = true;
            } else {
              ok = false;
            }
            this.gasLimit = gasParameters.GasLimit;
            console.log("gasPrameters : ", gasParameters);
            resolve({ version: this.version, AppVersion: AppVersion });
          }
        });
    });
  }

  //TEST
  /*


  fetchGasProdConfigFan() {
    firebase
      .database()
      .ref('/configFan')
      .once('value')
      .then(snapshot => {
        if (snapshot.val()) {
          var gasParameters = snapshot.val();
          this.gasPrice = gasParameters.GasPrice;
          this.minGas = gasParameters.minGas;
          var ok;
          if (this.minGas === 0.0000186) {
            ok = true;
          } else {
            ok = false;
          }
          this.gasLimit = gasParameters.GasLimit;
          console.log('gasPrameters : ', gasParameters);
        }
      });
  }

*/
  getGasPrice() {
    return this.gasPrice;
  }

  getGasLimit() {
    return this.gasLimit;
  }

  getMinGas() {
    return this.minGas;
  }

  getAmount() {
    return this.amount;
  }

  getAddressToSend() {
    return this.address_to;
  }
}



// WEBPACK FOOTER //
// ./src/services/config.service.ts